require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/fn/object/assign.js
// module id = 1986
// module chunks = 2